export default [
	    {
	        "id": "chat_messages__conversation_num",
	        "header": "Conversation Number",
	        "fieldName": "chat_messages__conversation_num",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    },
	    {
	        "id": "chat_messages__datetime",
	        "header": "Datetime",
	        "fieldName": "chat_messages__datetime",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 200
	    },
	    {
	        "id": "chat_messages__msg",
	        "header": "Msg",
	        "fieldName": "chat_messages__msg",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 200
	    }
	];